// extracted by mini-css-extract-plugin
export default {"container":"_e2351585","contentWrapper":"_86455358","header":"_5a7b04bd","icon":"_548b1ba9","button":"_165304f4","info":"_707b6c6c"};